import type { TimePickerLocale } from '../index';

const locale: TimePickerLocale = {
  placeholder: 'Select time',
  rangePlaceholder: ['Start time', 'End time'],
};

export default locale;
